import utils from '../../common/services/utils';
import moment from 'moment';

const getLessonAvailability = (lesson, lessonType) => {
	switch (lessonType) {
		case '':
		case 'normal':
			return lesson.availability;
		case 'trial':
			return lesson.trialAvailability;
		case 'makeup':
			return lesson.makeUpAvailability;
	}

	return '';
}

const getAvailability = (upcomingLessons, lessonType, paymentTypes, center) => {
	let availability = '';
	if (upcomingLessons.length == 0) {
		return '';
	}

	let numberOfTrialLessonsToValidate = center.trialLessonPrice > 0 && center.offerTrialAsPackage ? center.numberPaidTrialLesson : 1;

	if ((lessonType === 'trial' && numberOfTrialLessonsToValidate === 1 && !center.lockClassesForTrialChildren) || lessonType === 'makeup' ||
		(paymentTypes && paymentTypes.some(p => p.name === 'NormalSingle'))) {
		const nextLesson = upcomingLessons[0];
		availability = getLessonAvailability(nextLesson, lessonType);
	}
	else {
		if (lessonType === 'trial' && center.lockClassesForTrialChildren) {
			//check first numberOfTrialLessonsToValidate for trial and next lessons for normal
			const trialLessonsAvailability = upcomingLessons.slice(0, numberOfTrialLessonsToValidate)
				.map(x => getLessonAvailability(x, lessonType));
			const normalLessonsAvailability = upcomingLessons.slice(numberOfTrialLessonsToValidate, upcomingLessons.length)
				.map(x => getLessonAvailability(x, 'normal'));
			availability = trialLessonsAvailability.includes('No') || normalLessonsAvailability.includes('No') ? 'No' :
				trialLessonsAvailability.includes('LastSpot') || normalLessonsAvailability.includes('LastSpot') ? 'LastSpot' :
					trialLessonsAvailability.includes('Limited') || normalLessonsAvailability.includes('Limited') ? 'Limited' : 'Yes';
		}
		else {
			const lessonCountToCheck = paymentTypes && paymentTypes.some(p => p.name === 'NormalMonth') ? 4 : upcomingLessons.length;
			const lessonsAvailability = upcomingLessons.slice(0, lessonCountToCheck)
				.map(x => getLessonAvailability(x, lessonType));
			availability = lessonsAvailability.includes('No') ? 'No' :
				lessonsAvailability.includes('LastSpot') ? 'LastSpot' :
					lessonsAvailability.includes('Limited') ? 'Limited' : 'Yes';
		}

	}
	return availability;
}

const getWeeklyProgramItemAvailability = (weeklyProgramItem, lessonType, paymentTypes) => {
	const now = new Date();
	const upcomingLessons = weeklyProgramItem.lessons.filter(x => {
		const lessonStartTime = moment(x.start).utcOffset(weeklyProgramItem.center.utcOffset, true);	// actual start time using center's timezone
		return lessonStartTime > now;
	});
	return getAvailability(upcomingLessons, lessonType, paymentTypes, weeklyProgramItem.center);
}

const findNearbyCentersWithAvailableSpotsByLesson = (selectedCenter, selectedLesson, lessonType, allCenters, allLessons, maxDistance = 5) => {
	if (!selectedCenter || !selectedCenter.latitude || !selectedCenter.longitude) {
		return [];
	}

	const closestCenters = utils.findClosestCenters(selectedCenter, allCenters, maxDistance);

	return closestCenters.filter(center => {
		// filter programs for this center, grade and term
		const centerLessons = allLessons.filter(x => x.centerId === center.id &&
			x.termId === selectedLesson.termId &&
			x.gradeId === selectedLesson.gradeId);

		// check if there are any available spots
		return centerLessons.some(lesson => {
			return getLessonAvailability(lesson, lessonType) !== 'No';
		});
	});
};

const findNearbyCentersWithAvailableSpotsByWeeklyProgram = (selectedCenter, selectedProgram, lessonType, paymentTypes, allCenters, weeklyProgram, maxDistance = 5) => {
	if (!selectedCenter || !selectedCenter.latitude || !selectedCenter.longitude) {
		return [];
	}

	const closestCenters = utils.findClosestCenters(selectedCenter, allCenters, maxDistance);

	return closestCenters.filter(center => {
		// filter programs for this center, grade and term
		const centerPrograms = weeklyProgram.filter(program =>
			program.centerId === center.id &&
			program.termId === selectedProgram.termId &&
			program.gradeId === selectedProgram.gradeId &&
			program.isOneOffLesson === selectedProgram.isOneOffLesson
		);

		// check if there are any available spots
		return centerPrograms.some(program => {
			return getWeeklyProgramItemAvailability(program, lessonType, paymentTypes) !== 'No';
		});
	});
};

export default {
	getLessonAvailability,
	getAvailability,
	getWeeklyProgramItemAvailability,
	findNearbyCentersWithAvailableSpotsByLesson,
	findNearbyCentersWithAvailableSpotsByWeeklyProgram
};